import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import './style.less';

const heroSlides = [
  {
    image: '/images/hero/hero-1.jpg',
    translationKey: 'slide1',
  },
  {
    image: '/images/hero/hero-2.jpg',
    translationKey: 'slide2',
  },
  {
    image: '/images/hero/hero-3.jpg',
    translationKey: 'slide3',
  },
];

export const Hero = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance timer - resets when currentSlide changes (manual navigation)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <div className="hero">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-slide"
        >
          <div
            className="hero-image"
            style={{ backgroundImage: `url(${heroSlides[currentSlide].image})` }}
          />
          <div className="hero-overlay" />
          <div className="hero-content">
            <motion.h1
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
            >
              {t(`hero.${heroSlides[currentSlide].translationKey}.title`)}
            </motion.h1>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              {t(`hero.${heroSlides[currentSlide].translationKey}.subtitle`)}
            </motion.p>
          </div>
        </motion.div>
      </AnimatePresence>

      <button className="hero-nav hero-nav-prev" onClick={prevSlide} aria-label="Previous slide">
        <i className="fas fa-chevron-left"></i>
      </button>
      <button className="hero-nav hero-nav-next" onClick={nextSlide} aria-label="Next slide">
        <i className="fas fa-chevron-right"></i>
      </button>

      <div className="hero-indicators">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
